import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { Transition } from '@uirouter/core';

import { Observable, Subscription } from 'rxjs';

import { GlobalNav, Util, XmStore, XmStoreUtil } from 'core/services';
import { CmsMyAccount } from 'store/cms/models';
import { TransitionHooks } from 'core/constants';
import { Account, User } from 'store/user/models';
@Component({
    selector: 'my-account-menu',
    styleUrls: ['./menu.scss'],
    templateUrl: './menu.html',
    standalone: false
})
export class MyAccountMenuComponent implements OnInit, OnDestroy {
    @Output() public activeTabName: EventEmitter<string> = new EventEmitter<string>();
    public pageData: CmsNavMenuItems[];
    public enableLineLevelExperience: boolean = false;
    public accountData: Account;

    private subscriptions: Subscription[] = [];
    private transitionSuccess: Observable<Transition>;
    private xmStore: XmStore;
    private navService: GlobalNav;

    constructor(navService: GlobalNav, xmStore: XmStore, @Inject(TransitionHooks.SUCCESS) transitionSuccess: Observable<Transition>) {
        Object.assign(this, { navService, xmStore, transitionSuccess });
    }

    public ngOnInit(): void {

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsMyAccount>(CmsMyAccount), (cmsMyAccount: CmsMyAccount) => {
            this.pageData = cmsMyAccount.secondaryMenuItems;
            
            this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peekChild<Account, User>('account', Account, User), (account: Account) => {
                this.accountData = account;     
                this.pageData = this.pageData.filter((page: CmsNavMenuItems) => {
                    if (this.accountData.isMember || this.accountData.isViewer) {
                        return (page.name !== 'Billing');
                    }

                    return true;
                }); 
            }));

            this.emitActiveTab();
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.transitionSuccess, () => {
            this.emitActiveTab();
        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    private emitActiveTab(): void {
        this.pageData.forEach((page: CmsNavMenuItems) => {
            if (this.navService.stateActive(page)) {
                this.activeTabName.emit(page.name);

                return;
            }
        });
    }
}
